
import _ from 'lodash';
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import DetailTable from 'Modules/dashboard/views/.components/dashboardPanel/.components/detailTable';

//Actions
import {
    firmwareRequestDetailsRequest,
    clearRedux,
} from 'Redux/actions';

const FirmwareDetails = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const {
        openModal,
        loading,
        result,
        data
    } = useSelector(state => state.firmwareDetailsRedux);

    const [columns, setColumns] = useState([]);

    const closeModal = () => {
        dispatch(clearRedux("FIRMWARE_REQUESTS_DETAILS"))
        setColumns([])
    }

    useEffect(() => {
        if (openModal && data?.firmwareId) {
            let id = data?.firmwareId !== "NA" ? data?.firmwareId : null
            let payload = {
                id: data?.gadgetId,
                query: {
                    level: 1,
                    gadgetParams: JSON.stringify({ firmwareId: id })
                }
            }
            dispatch(firmwareRequestDetailsRequest(payload))
        }
        return () => {
            dispatch(clearRedux("FIRMWARE_REQUESTS_DETAILS"))
        }
    }, [openModal])

    return (
        <div className='create-edit-modal'>
            <Modal
                open={openModal}
                title={`Firmware Id (${data?.firmwareId})`}
                handleClose={() => closeModal()}
                position="right"
                loading={loading || columns?.length === 0}
                size="medium"
            >
                <ModalBody>
                    {result && <DetailTable result={result} onChangeColumns={setColumns} />}
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => closeModal()}
                    >
                        {messages['common_close']}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default FirmwareDetails;